<template>
  <footer class="footer">
    <span>
        2019 Copyright
        <b-icon
          pack="fas"
          icon="copyright"
          size="is-small"
        >
        </b-icon>
        <br>
        Made with
        <b-icon
          pack="fas"
          icon="heart"
          size="is-medium"
          type="is-danger"
        >
        </b-icon>
        from Iyawat K.
    </span>
  </footer>
</template>

<script>
export default {
}
</script>

<style scoped>

  .footer {
    left: 0;
    bottom: 0;
    height: 10%;
    width: 100%;
    text-align: center;
    background-color:rgb(76, 0, 114);
    color: #F4F4F4;
    font-weight: 500;
    padding: 2vh 0px 2vh 0px;
  }
</style>
